import { ShieldCheck, ChefHat, Wrench, Factory, Check } from "lucide-react";

const ICONS = [ShieldCheck, ChefHat, Wrench, Factory];

const ExtraServices = ({ t }) => {
  return (
    <section
      id="extra-services"
      data-testid="extra-services-section"
      className="bg-[#f8f9fa] py-24 sm:py-32 border-t border-[#0a192f]/10"
    >
      <div className="bid-container">
        <div className="max-w-3xl mb-14">
          <p className="bid-overline text-[#d4af37] mb-4">{t.extraServices.overline}</p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-display font-black text-[#0a192f] tracking-tight leading-tight"
            data-testid="extra-services-title"
          >
            {t.extraServices.title}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#4a5568] leading-relaxed">
            {t.extraServices.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0a192f]/10 border border-[#0a192f]/10">
          {t.extraServices.items.map((s, i) => {
            const Icon = ICONS[i] || ShieldCheck;
            return (
              <article
                key={i}
                data-testid={`extra-service-${i}`}
                className="bg-white flex flex-col group hover:bg-[#0a192f] transition-colors duration-300 overflow-hidden"
              >
                {/* Image Area */}
                <div className="w-full h-64 sm:h-64 lg:h-72 bg-white flex-shrink-0 overflow-hidden flex items-center justify-center">
                  <img
                    src={s.image || `https://placehold.co/600x400/f8f9fa/a0aec0?text=Imagem+${encodeURIComponent(s.title)}`}
                    alt={s.title}
                    className="w-full h-full object-contain sm:object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>

                <div className="p-8 lg:p-10 flex flex-col flex-grow">
                  <div className="w-14 h-14 flex items-center justify-center border-2 border-[#0a192f] group-hover:border-[#d4af37] mb-6 transition-colors">
                    <Icon className="w-6 h-6 text-[#0a192f] group-hover:text-[#d4af37] transition-colors" strokeWidth={1.5} />
                  </div>

                  <h3 className="font-display text-xl sm:text-2xl font-bold text-[#0a192f] group-hover:text-white transition-colors leading-snug">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-[#4a5568] group-hover:text-white/70 transition-colors leading-relaxed">
                    {s.desc}
                  </p>

                  <ul className="mt-6 space-y-2 pt-6 border-t border-[#0a192f]/10 group-hover:border-white/10 transition-colors">
                    {s.features.map((f, j) => (
                      <li
                        key={j}
                        className="flex gap-2 items-start text-xs text-[#0a192f]/80 group-hover:text-white/80 transition-colors"
                      >
                        <Check className="w-3.5 h-3.5 text-[#d4af37] mt-0.5 flex-shrink-0" strokeWidth={3} />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExtraServices;
